import { createCallScorecardDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const createCallScorecardCallable = getCallable(
  createCallScorecardDefinition,
);
